/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoSincronizzazioneKeycloakDTO { 
    allineato?: boolean;
    stato_precedente?: CittadinoSincronizzazioneKeycloakDTOStatoPrecedenteEnum;
    stato_attuale?: CittadinoSincronizzazioneKeycloakDTOStatoAttualeEnum;
    keycloak_abilitato?: boolean;
    brute_force_bloccato?: boolean;
    tentativi_falliti?: number;
    ultimo_tentativo_fallito?: string;
}
export enum CittadinoSincronizzazioneKeycloakDTOStatoPrecedenteEnum {
    NESSUNA_EMAIL = 'NESSUNA_EMAIL',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_ATTIVAZIONE = 'IN_ATTESA_ATTIVAZIONE',
    DISABILITATO = 'DISABILITATO',
    ATTIVO = 'ATTIVO'
};
export enum CittadinoSincronizzazioneKeycloakDTOStatoAttualeEnum {
    NESSUNA_EMAIL = 'NESSUNA_EMAIL',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_ATTIVAZIONE = 'IN_ATTESA_ATTIVAZIONE',
    DISABILITATO = 'DISABILITATO',
    ATTIVO = 'ATTIVO'
};



